import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  typography: {
    width: 'fit-content',
  },
}))

export default styles
